import React from 'react'
import { useSession } from 'src/sdk/session'
import { useSelectContentEvent } from 'src/sdk/analytics/hooks/useSelectContentEvent'
import { getCookie, setCookie } from 'src/utils/cookie'
import { filteredInLinkWithFacets } from 'src/utils/filteredInLinkWithFacets'
import { Link } from 'gatsby'
import { Image } from 'src/components/ui/Image'

import type { NavigationCategoryProps } from './index'
import { formatAlt } from '../../../utils/formatAlt'

type StyleImage = {
  width?: number
  height?: number
}

type ThumbsProps = {
  banner: NavigationCategoryProps
  promotion?: boolean
  campaignEco?: string
  actionType?: string
  categoryClick?: string
  collectionClick?: string
  menuUrl?: string
  pageType?: string
  style: string
  textcolor: string | undefined
  categoryClass: string
  styleImage: StyleImage | null
  loading: 'lazy' | 'eager' | undefined
}

function Thumbs({
  banner,
  promotion,
  campaignEco,
  actionType,
  categoryClick,
  collectionClick,
  menuUrl,
  pageType,
  style,
  textcolor,
  categoryClass,
  styleImage,
  loading = 'lazy',
}: ThumbsProps) {
  const { person } = useSession()
  const { sendSelectContentEvent } = useSelectContentEvent()
   const uuidToUse = getCookie('uuid')

  return (
    <button
      className="btn-thumb"
      onClick={() => {
        if (promotion) {
          sendSelectContentEvent({
            campaign_eco: campaignEco,
            action_type: actionType as string,
            category_click: categoryClick as string,
            collection_click: collectionClick as string,
            menu_url: menuUrl as string,
            user_logged: !!person?.id,
            user_id: person?.id ?? null,
            pageType: pageType as string,
            uuid: uuidToUse,
          })

          if (campaignEco) {
            setCookie('campanhaEco', campaignEco, 7, '.vivara.com.br')
          }
        }
      }}
    >
      <Link
        to={filteredInLinkWithFacets(banner?.href)}
        aria-label={`Link para a coleção ${
          formatAlt(banner?.alt ?? '')?.altFormat
        }`}
        key={`${formatAlt(banner?.alt ?? '')?.altFormat}`}
        className={`${categoryClass}-link-area ${style}`}
      >
        <Image
          baseUrl={banner?.src}
          alt={`${formatAlt(banner?.alt ?? '')?.altFormat}`}
          aspectRatio={1}
          layout="constrained"
          backgroundColor="#F0F0F0"
          loading={loading}
          {...(styleImage && {
            sourceWidth: styleImage?.width,
            sourceHeight: styleImage?.height,
          })}
          options={{
            fitIn: true,
          }}
        />
        <h3 style={{ color: textcolor }}>{banner?.label}</h3>
      </Link>
    </button>
  )
}

export default Thumbs
